module.exports = __webpack_public_path__ + "img/life_cycle_management.da8175b6.png";